/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hide_Error_Details_ButtonInputs */

const en_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide details`)
};

const id_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan detail`)
};

const ms_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan butiran`)
};

const ca_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oculta els detalls`)
};

const cs_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt podrobnosti`)
};

const da_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul oplysninger`)
};

const de_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details ausblenden`)
};

const et_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peida üksikasjad`)
};

const es_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar detalles`)
};

const fr_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les détails`)
};

const hr_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakrij detalje`)
};

const it_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi dettagli`)
};

const lv_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slēpt detaļas`)
};

const lt_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slėpti išsamią informaciją`)
};

const hu_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Részletek elrejtése`)
};

const nl_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verberg details`)
};

const nb_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul detaljer`)
};

const pl_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukryj szczegóły`)
};

const pt_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar detalhes`)
};

const ro_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascunde detaliile`)
};

const sk_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skryť podrobnosti`)
};

const sl_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrij podrobnosti`)
};

const fi_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piilota lisätiedot`)
};

const sv_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dölj detaljer`)
};

const vi_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ẩn chi tiết`)
};

const tr_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detayları gizle`)
};

const el_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Απόκρυψη λεπτομερειών`)
};

const bg_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скриване на подробностите`)
};

const ru_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть`)
};

const sr_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сакриј детаље`)
};

const uk_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сховати подробиці`)
};

const ka_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დეტალების დამალვა`)
};

const hi_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण छुपाएं`)
};

const th_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซ่อนรายละเอียด`)
};

const ko_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세부 정보 숨기기`)
};

const zh_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏详细信息`)
};

const zh_tw_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱藏詳細資訊`)
};

const ja_hide_error_details_button = /** @type {(inputs: Hide_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細を非表示`)
};

/**
* | output |
* | --- |
* | "Hide details" |
*
* @param {Hide_Error_Details_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const hide_error_details_button = /** @type {((inputs?: Hide_Error_Details_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hide_Error_Details_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hide_error_details_button(inputs)
	if (locale === "ms") return ms_hide_error_details_button(inputs)
	if (locale === "ca") return ca_hide_error_details_button(inputs)
	if (locale === "cs") return cs_hide_error_details_button(inputs)
	if (locale === "da") return da_hide_error_details_button(inputs)
	if (locale === "de") return de_hide_error_details_button(inputs)
	if (locale === "et") return et_hide_error_details_button(inputs)
	if (locale === "es") return es_hide_error_details_button(inputs)
	if (locale === "fr") return fr_hide_error_details_button(inputs)
	if (locale === "hr") return hr_hide_error_details_button(inputs)
	if (locale === "it") return it_hide_error_details_button(inputs)
	if (locale === "lv") return lv_hide_error_details_button(inputs)
	if (locale === "lt") return lt_hide_error_details_button(inputs)
	if (locale === "hu") return hu_hide_error_details_button(inputs)
	if (locale === "nl") return nl_hide_error_details_button(inputs)
	if (locale === "nb") return nb_hide_error_details_button(inputs)
	if (locale === "pl") return pl_hide_error_details_button(inputs)
	if (locale === "pt") return pt_hide_error_details_button(inputs)
	if (locale === "ro") return ro_hide_error_details_button(inputs)
	if (locale === "sk") return sk_hide_error_details_button(inputs)
	if (locale === "sl") return sl_hide_error_details_button(inputs)
	if (locale === "fi") return fi_hide_error_details_button(inputs)
	if (locale === "sv") return sv_hide_error_details_button(inputs)
	if (locale === "vi") return vi_hide_error_details_button(inputs)
	if (locale === "tr") return tr_hide_error_details_button(inputs)
	if (locale === "el") return el_hide_error_details_button(inputs)
	if (locale === "bg") return bg_hide_error_details_button(inputs)
	if (locale === "ru") return ru_hide_error_details_button(inputs)
	if (locale === "sr") return sr_hide_error_details_button(inputs)
	if (locale === "uk") return uk_hide_error_details_button(inputs)
	if (locale === "ka") return ka_hide_error_details_button(inputs)
	if (locale === "hi") return hi_hide_error_details_button(inputs)
	if (locale === "th") return th_hide_error_details_button(inputs)
	if (locale === "ko") return ko_hide_error_details_button(inputs)
	if (locale === "zh") return zh_hide_error_details_button(inputs)
	if (locale === "zh-tw") return zh_tw_hide_error_details_button(inputs)
	if (locale === "ja") return ja_hide_error_details_button(inputs)
	return en_hide_error_details_button(inputs)
});